import { FormEvent } from 'react';
import { IListItem } from '@nkr/models/list-item';
import { Col, ControlLabel, FormControl, FormGroup } from 'react-bootstrap';

interface IProps {
    relationshipToRecipient: string,
    relationshipToPatientOther: string,
    relationshipToPatientList: IListItem[],
    onTextChange: (e: FormEvent<FormControl & HTMLInputElement>) => void
}

const RelationshipToRecipient = (props: IProps) => {
    return (
        <>
            <FormGroup>
                <Col xs={12} lg={2} componentClass={ControlLabel}>Relationship to Recipient:</Col>
                <Col xs={12} lg={4}>
                    <FormControl
                        componentClass='select'
                        name='relationshipToRecipient'
                        value={props.relationshipToRecipient}
                        onChange={props.onTextChange}
                    >
                        <option value={''}>- Select -</option>
                        {props.relationshipToPatientList.filter(x => x.description != 'Other').map(item =>
                            <option key={'rel-' + item.id} value={item.description}>{item.description}</option>
                        )}
                    </FormControl>
                </Col>
            </FormGroup>

            {/* {props.relationshipToRecipient == 'Other' && (
                <FormGroup>
                    <Col xs={12} lg={2} componentClass={ControlLabel}>Other:</Col>
                    <Col xs={12} lg={4}>
                        <FormControl
                            componentClass='input'
                            name='relationshipToPatientOther'
                            maxLength={30}
                            value={props.relationshipToPatientOther}
                            onChange={props.onTextChange}
                        />
                    </Col>
                </FormGroup>
            )} */}
        </>
    );
}

export default RelationshipToRecipient;